/**
 * 门户返回默认配置数据
 */
export const home = [{
    color: "rgba(0, 0, 0, 0.8)",
    bgColor: "rgba(255,255,255, 1)",
    borderTopLeftRadius: 37,
    borderTopRightRadius: 37,
    borderBottomLeftRadius: 37,
    borderBottomRightRadius: 37,
    showIcon: true,
    showReturnText: true,
    iconStyle: 1,
  },
  {}
]

/**
 * 大屏返回默认配置数据
 */
export const bs = [{
    color: "rgba(255,255,255,1)",
    bgColor: "rgba(0, 0, 0, 0.8)",
    borderTopLeftRadius: 37,
    borderTopRightRadius: 37,
    borderBottomLeftRadius: 37,
    borderBottomRightRadius: 37,
    showIcon: true,
    showReturnText: true,
    iconStyle: 1,
  },
  {}
]

/**
 * app返回默认配置数据
 */
export const appHome = [{
  color: "rgba(0, 0, 0, 0.8)",
  bgColor: "rgba(255,255,255, 1)",
  borderTopLeftRadius: 37,
  borderTopRightRadius: 37,
  borderBottomLeftRadius: 37,
  borderBottomRightRadius: 37,
  showIcon: true,
  showReturnText: true,
  iconStyle: 1,
},
  {}
]
